import type {
  AccountAllocationListItem,
  AccountAllocationListParams,
  AccountAllocationLogListResponse,
} from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { formatDateRange } from '#/utils'

export const accountAllocationApi = defineApi('operation', ({ prefix }) => {
  function getAccountAllocationListParams(
    params: PagingRequest<AccountAllocationListParams>,
  ) {
    const condition = params.condition
    return {
      accountId: condition?.accountId,
      accountName: condition?.accountName,
      accountStatus: condition?.accountStatus?.map(Number),
      accountType: condition?.accountType,
      agency: condition?.agency,
      allocationTime: formatDateRange(condition?.allocationTime),
      amOpenIds: condition?.amOpenIds,
      bdOpenIds: condition?.bdOpenIds,
      customerId: condition?.customerId,
      mediaPlatform: condition?.mediaPlatform,
      nickname: condition?.nickname,
      userId: condition?.userId,
    }
  }

  function getAccountAllocationList(
    params: PagingRequest<AccountAllocationListParams>,
  ) {
    params.condition = getAccountAllocationListParams(params)

    return requestClient
      .post(prefix('adsAccount/queryAdsAccountAllocationList'), params)
      .then((res) => {
        return {
          items: res?.list?.map((item: AccountAllocationListItem) => ({
            id: item.id,
            accountId: item.accountId,
            accountName: item.accountName,
            accountStatus: item.accountStatus,
            accountType: item.accountType,
            agency: item.agency,
            amOpenId: item.amOpenId,
            balance: item.balance,
            bdOpenId: item.bdOpenId,
            currency: item.currency,
            allocationTime: item.allocationTime,
            userId: item.userId,
            nickname: item.nickname,
            customerId: item.customerId,
            allocationBy: item.allocationBy,
            mediaPlatform: item.mediaPlatform,
          })),
          total: res?.total,
        }
      })
  }

  function getAccountAllocationLogList(
    params: PagingRequest<AccountAllocationListParams>,
  ) {
    const condition = getAccountAllocationListParams(params)

    return requestClient
      .post<AccountAllocationLogListResponse>(
        prefix('adsAccount/queryAdsAccountAllocationLogList'),
        {
          condition,
          pageIndex: params.pageIndex,
          pageSize: params.pageSize,
        },
      )
      .then((res) => {
        return {
          items: res?.list?.map((item) => ({
            id: item.id,
            accountId: item.accountId,
            accountName: item.accountName,
            accountStatus: item.accountStatus,
            accountType: item.accountType,
            agency: item.agency,
            amOpenId: item.amOpenId,
            balance: item.balance,
            bdOpenId: item.bdOpenId,
            currency: item.currency,
            allocationTime: item.allocationTime,
            operType: item.operType,
            userId: item.userId,
            nickname: item.nickname,
            customerId: item.customerId,
            allocationBy: item.allocationBy,
            mediaPlatform: item.mediaPlatform,
            validFrom: item.validFrom,
            validTo: item.validTo,
          })),
          total: res.total,
        }
      })
  }
  function getCompanyList() {
    return requestClient.post(prefix('companies/allCompany')).then((res) => {
      return res?.map((item: any) => ({
        label: item.name,
        value: String(item.id),
        customerId: item.customerId,
      }))
    })
  }
  function getAllUser() {
    return requestClient.post(prefix('users/allUser')).then((res) => {
      return res?.map((item: any) => ({
        label: item.nickname,
        code: String(item.id),
        value: item.companyId,
        customerId: item.customerId,
      }))
    })
  }

  return {
    getAccountAllocationList,
    getAccountAllocationLogList,
    getAccountAllocationListParams,
    getCompanyList,
    getAllUser,
  }
})
